const INPUT_PROPS = {
  autoCapitalize: 'autocapitalize',
  autoComplete: 'autocomplete',
  autoCorrect: 'autocorrect',
  autoFocus: 'autofocus',
  inputMode: 'inputmode',
  maxLength: 'maxlength',
  minLength: 'minlength',
  readOnly: 'readonly',
  spellCheck: 'spellcheck'
};

export default INPUT_PROPS;
